<div
  class="c-mosaik"
  [ngClass]="{
    'c-mosaik--single-item': galleryData.length <= 1,
    'c-mosaik--two-col': galleryData.length > 1 && galleryData.length <= 3
  }"
>
  <app-element-loader
    [loadingMessage]="loadingGalleryModalMessage"
    [loadingStatus]="loadingGalleryModalStatus"
    class="position-absolute"
  ></app-element-loader>

  <ng-container *ngIf="galleryData.length">
    <div
      class="c-mosaik__big"
      [ngClass]="{ 'is-1': galleryData.length === 1 }"
    >
      <div class="c-mosaik__item" (click)="openGallery(galleryData[0])">
        <picture>
          <img
            [src]="galleryData[0]"
            [showPlaceholderOnError]="true"
            alt=""
          />
        </picture>
      </div>
    </div>
    <div
      class="c-mosaik__small"
      [ngClass]="{
        'd-none': galleryData.length === 1,
        'is-2': galleryData.length <= 3
      }"
    >
      <ng-container *ngFor="let image of galleryData.slice(1, 8)">
        <div class="c-mosaik__item" (click)="openGallery(image)">
          <picture>
            <img
              [src]="image"
              [showPlaceholderOnError]="true"
              alt=""
            />
          </picture>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <ng-container *ngIf="galleryData.length === 0">
    <div class="c-mosaik__big is-1">
      <div class="c-mosaik__item">
        <picture>
          <img
            [src]="'assets/images/placeholders/img.png'"
            [showPlaceholderOnError]="true"
            alt=""
          />
        </picture>
      </div>
    </div>
  </ng-container>

  <div class="c-mosaik__cta" *ngIf="galleryData.length">
    <a (click)="openGallery(null)">
      <span class="icon-gallery"></span>
      <span class="c-mosaik__cta-label">Galleria</span>
    </a>
  </div>
</div>
